module.exports = __webpack_public_path__ + "images/organization/blue-face.a0ee4f9a807f04212231.svg";